export default __webpack_public_path__ + "5cea7773b1b773c2c7cd1a28231a1c45.png";